import UserEvent from "../../../core/internal/event/UserEvent"
import Logger from "../../../core/internal/logger"
import { InAppMessageTriggerDeterminer } from "./InAppMessageTriggerDeterminer"
import { InAppMessageTriggerHandler } from "./InAppMessageTriggerHandler"

export class InAppMessageTriggerProcessor {
  constructor(
    private readonly determiner: InAppMessageTriggerDeterminer,
    private readonly handler: InAppMessageTriggerHandler
  ) {}

  process(event: UserEvent) {
    try {
      const trigger = this.determiner.determine(event)
      if (!trigger) return

      Logger.log.debug(`InAppMessage triggered: ${trigger}`)

      this.handler.handle(trigger)
    } catch (e) {
      Logger.log.error(`Failed to process InAppMessage event trigger: ${e}`)
    }
  }
}
